import styled from 'styled-components'
import { fadeIn, slideInFromRight } from '../../styles/Animations'

export const LogoContainer = styled.div`
  padding: 10px 0 10px 100px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  animation: ${fadeIn} 0.5s ease-in-out;

  img{
    width: 90px;

    @media (max-width: 550px) {
      /* Phones */
      width: 90px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 90px;
    }

    @media (max-width: 1300px) {
      /* Small desktop */
      width: 90px;
    }
  }

  @media (max-width: 550px) {
    /* Phones */
    padding: 0 0 0 15px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    padding: 0 0 0 15px;
  }

  @media (max-width: 1300px) {
    /* Small desktop */
    padding: 0 0 0 15px;
  }
`

export const MenuContainer = styled.div`
  display: flex;
  background-color: white;
  justify-content: space-between;
  color: #282C34;
  align-items: center;
  padding: 0px 30px 0 30px;
  
  @media (max-width: 550px) {
    /* Phones */
    padding: 0 0 0px 0;
    grid-template-columns: 100%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    padding: 0 0 0 0;
    grid-template-columns: 100%;
  }

  @media (max-width: 1300px) {
    /* Small desktop */
    padding: 0 0 0 15px;
    grid-template-columns: 100%;
  }
`

export const MenuItems = styled.div`
  display: flex;
  width: 70%;

  @media (max-width: 550px) {
    /* Phones */
    display: none;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: none;
  }

  @media (max-width: 1300px) {
    display: none;
  }
`

export const MenuItem = styled.div`
  animation: ${slideInFromRight} 0.3s ease-in-out;
  width: auto;

  margin-right: 16px;
  p{
    text-transform: uppercase;
    font-weight: 500;
    text-align: center;

    @media (min-width: 1200px) and (max-width: 1500px) {
      /* Tablets */
      font-size: 0.8em;
    }
  }

  a{
    color: white;
    text-decoration: none;

    &:hover{
      color: white;
      transition: color 0.2s;
    }
  }
`

export const RedLink = styled.p`
  a{
    color: #282C34;
    text-decoration: none;

    &:hover{
      color: #EA0B2A;
      transition: color 0.2s;
    }
  }
`

export const SignInContainer = styled.div`
  width: 30%;
  height: 25px;
  display: flex;

  align-items: center;
  font-size: 1.2em;

  &:hover{
    cursor: pointer
  }

  a{
    color: #282C34;
    text-decoration: none;
    margin-top: 5px;

    &:hover{
      text-decoration: underline;
      transition: color 0.2s;
    }
  }

  p{
    font-size: 0.7em;
    margin-left: 5px;
    margin-top: 2px;

    @media (max-width: 550px) {
      /* Phones */
      margin-left: 5px;
      width: 80px;
      font-size: 0.6em;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      font-size: 0.6em;
    }
  }

  div{
    border: 1px solid white;
    padding: 0px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: grid;
    align-items: center;
    justify-content: center;
    font-size: 0.8em;
  }

  @media (max-width: 550px) {
    /* Phones */
    width: 100%;
    margin-right: 15px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100%;
  }

  @media (max-width: 1300px) {
    width: 100%;
  }
`

export const MobileMenu = styled.div`
  display: none;
  font-size: 2em;

  div{
    border: 1px solid white;
    padding: 5px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;

    &:hover{
      cursor: pointer;
    }
  }

  @media (max-width: 550px) {
    /* Phones */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
  }

  @media (max-width: 1300px) {
    /* Small desktop */
    display: flex;
    align-items: center;
    justify-content: end;
  }
`

export const DropdownMenu = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  background: #282C34;
  color: black;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 5px;
  z-index: 10;
  min-width: 150px;
  color: white !important;
`;

export const DropdownItem = styled.a.attrs(props => ({
  as: props.as || 'a'
}))`
  display: block;
  padding: 8px 12px;
  text-decoration: none;
  border-radius: 10px;
  color: white;
  &:hover {
    background: #EA0B2A;
    color: white;
  }
`;

export const MenuItemArrow = styled.div`
display: flex;
align-items: center;
justify-content: center;
&:hover{
      color: #EA0B2A;
      transition: color 0.2s;
    }
p{
  margin-right: 5px;
}
`;

export const LoginStatusBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  padding: 5px 10px;
  border-radius: 5px;
  color: #EA0B2A;
  margin-left: 12px;

  &:hover{
    cursor: pointer;
  }

  
  svg {
    margin-right: 10px;
  }

  p {
    font-size: 0.9em;
    margin: 0;
  }

  @media (max-width: 1300px) {
    display: none;
  }
`;
